// extracted by mini-css-extract-plugin
module.exports = {"container":"info-modal-container__2pdw9","text":"info-modal-text__1u4ec","button":"info-modal-button__1Xi7W"};